import get from 'lodash.get';

export const getAccumulativeOrdersRate = (fulfillmentPlans) => {
  const initObj = {
    value: 0,
    errors: [],
    missingCostReviewDataCount: 0,
  };
  const zeroRate = { value: 0, errors: [] };
  const getAccumulateFulfillmentPlansRate = (rateAcc, fulfillmentPlan) => {
    const totalCost = get(fulfillmentPlan, 'rateSummary.rate.totalCost', zeroRate);
    const labelConfiguration = get(fulfillmentPlan, 'labelConfiguration', {});
    const error = get(fulfillmentPlan, 'rateSummary.rateError');
    const newErrors = error ? [error] : [];
    const nonRatedPlan = totalCost?.value === 0 ? 1 : 0;
    let invalidOrder = 0;
    if (nonRatedPlan === 1) {
      const hasEmptyPackage =
        !labelConfiguration?.packages?.length || labelConfiguration?.packages.some((packageData) => !packageData.packageTypeId);
      invalidOrder = !labelConfiguration?.sellerLabelProviderId || hasEmptyPackage ? 1 : 0;
    }
    return {
      value: rateAcc.value + totalCost.value,
      code: rateAcc.code || totalCost.code,
      errors: [...rateAcc.errors, ...newErrors],
      missingCostReviewDataCount: rateAcc.missingCostReviewDataCount + invalidOrder,
    };
  };

  return fulfillmentPlans.reduce(getAccumulateFulfillmentPlansRate, initObj);
};
